import { IconLockOpen } from "@tabler/icons-react";
import { useMutation } from "@tanstack/react-query";
import { Button, Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui";
import { toastErrorApi, toastExito } from "@/lib/toast";
import { prorrateoApi } from "../../services/prorrateo.api";

/**
 * Botón pequeño para reabrir un prorrateo de CFDI ya confirmado. Solo
 * se muestra cuando el CFDI está confirmado y la solicitud aún no
 * pasó a autorización.
 */
export function ReabrirCfdiBoton({ solicitudId, numeroCfdi, onReabierto }: { solicitudId: string; numeroCfdi: number; onReabierto: () => void }) {
  const m = useMutation({
    mutationFn: () => prorrateoApi.reabrir(solicitudId, numeroCfdi),
    onSuccess: () => {
      toastExito({ title: `CFDI ${numeroCfdi} reabierto`, message: "Puedes editar las líneas." });
      onReabierto();
    },
    onError: toastErrorApi,
  });
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button variant="default" size="xs" leftSection={<IconLockOpen size={12} />} loading={m.isPending} onClick={() => m.mutate()}>
          Reabrir
        </Button>
      </TooltipTrigger>
      <TooltipContent>Reabrir este prorrateo para corregirlo</TooltipContent>
    </Tooltip>
  );
}
